module.exports = __webpack_public_path__ + "img/tbs_logo.42b6eb65.png";